const isMobile = () => {
    return window.innerWidth <= 700;
}
export {isMobile}
